const modelName = 'Privacy Categories';
const modelNameSingular = 'Privacy Category';
const endpoint = '/privacy-policy-categories';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: true,
    canAddNew: true,
    canSearch: true,
    endpoint,
    accessor: 'id',
};

export default setup;
